import { z } from 'zod';

/**
 * Vordefinierte Kategorie-Slugs.
 * Neue Kategorien können in der DB angelegt werden — dieser Enum listet die bekannten.
 */
export const EventCategorySlugSchema = z.enum([
  'icon_league',
  'stammtisch',
  'watchparty',
  'sonstiges',
]);

/** TypeScript Type für bekannte Kategorie-Slugs */
export type EventCategorySlug = z.infer<typeof EventCategorySlugSchema>;

/**
 * Zod Schema für EventCategory — Runtime-Validierung + Type-Inference.
 * Flexible Kategorien als DB-Model (neue Kategorien ohne Migration).
 */
export const EventCategorySchema = z.object({
  id: z.string().cuid(),
  slug: z.string(),
  name: z.string(),
  color: z.string().default('#3B82F6'),
  icon: z.string().nullable().optional(),
  hasTicketing: z.boolean().default(false),
  hasScanner: z.boolean().default(false),
  isActive: z.boolean().default(true),
  sortOrder: z.number().int().default(0),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

/** TypeScript Type — abgeleitet aus dem Zod Schema */
export type EventCategory = z.infer<typeof EventCategorySchema>;

/**
 * Schema für EventCategory-Erstellung.
 * Slug ist optional — wird automatisch aus dem Namen generiert, wenn nicht angegeben.
 */
export const CreateEventCategorySchema = z.object({
  name: z.string().min(1),
  slug: z.string().optional(),
  color: z.string().optional(),
  icon: z.string().nullable().optional(),
  hasTicketing: z.boolean().optional(),
  hasScanner: z.boolean().optional(),
  isActive: z.boolean().optional(),
  sortOrder: z.number().int().optional(),
});

/** TypeScript Type für EventCategory-Erstellung */
export type CreateEventCategory = z.infer<typeof CreateEventCategorySchema>;

/**
 * Schema für EventCategory-Update.
 * Alle Felder optional — PATCH-Semantik.
 */
export const UpdateEventCategorySchema = CreateEventCategorySchema.partial();

/** TypeScript Type für EventCategory-Update */
export type UpdateEventCategory = z.infer<typeof UpdateEventCategorySchema>;
